import { Subject } from 'rxjs';
export class GridOptions {
    enableSorting = true;
    enableFilter = true;
    rowHeight = 35;
    floatingBottomRowData: any;
    columnDefs: any[] = [];
    rowData: any[] = [];
    setDataSource = new Subject<any>();
    onSetData$ = this.setDataSource.asObservable();
    setData(data: any[]) {
        // this.rowData = data;
        this.setDataSource.next(data);
    }
    constructor(defaults: any = {}) {
        Object.keys(defaults).map(key => {
            this[key] = defaults[key];
        });
    }
    onRowClicked = (a) => {
        // console.log('on Row Clicked', a);
    }
    onRowSelected = (a) => {
        // console.log('on Row selected', a);
    }
    onSelectionChanged = (a) => {
        // console.log('on Selection Changed', a);
    }
    onRowDoubleClicked = (e) => {
        // console.log('On row doble clicked', e);
    }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/common/ag-grid/ag-grid.model.ts